module.exports = "<div class=rm-grid-toolbar-user-management-roles></div>";